module.exports = __webpack_public_path__ + "static/img/mianfeizixun.06efe59.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/mianfeizixun.png
// module id = g4d7
// module chunks = 1